import ApiService from "@/core/services/api.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    startPairingDisplayConsultorio(context, dados) {
        return new Promise(resolve => {
            ApiService.post("displayConsultorio/startPairing", dados).then(({ data }) => {
                resolve(data);
            });
        });
    }, 
    statusPairingDisplayConsultorio(context, dados) {
        return new Promise(resolve => {
            ApiService.post("displayConsultorio/statusPairing", dados).then(({ data }) => {
                resolve(data);
            });
        });
    }, 
    currentStateDisplayConsultorio(context, dados) {
        return new Promise(resolve => {
            ApiService.post("displayConsultorio/currentState", dados).then(({ data }) => {
                resolve(data);
            });
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};